module.exports = __webpack_public_path__ + "img/qd.ab752013.jpg";